export default __webpack_public_path__ + "static/media/edit-active.a03cb6a2.svg";